import { getIsUngatedForSeats } from 'pricing-pages-lib/utils/gatingUtils';
import { createProductConfig } from 'pricing-pages-lib/utils/productConfigUtils';
import { MARKETING } from 'self-service-api/constants/ProductLines';
import { useAppSelector } from '../../../reducers';
import { productVersionFromProductInventorySelector } from '../../../selectors/ProductInventorySelectors';
import { currentSkuIdForProductSelector, productForSkuIdSelector, skuSelector } from '../../../selectors/ProductsSelectors';
import { usePricingLibSelector } from '../../../selectors/SelectorUtils';
import IncludedContacts from '../../merch-card/subtext-display/IncludedContacts';
import ContactsPickerCompactAll from './ContactsPickerCompactAll';
import SeatsPickerMerchCardPreSeats from './SeatsPickerMerchCardPreSeats';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const AdditionalUnitsPickerCompactAll = ({
  additionalUnitSkuId,
  additionalUnitQuantity,
  setAdditionalUnitQuantity,
  productConfigurations,
  trackingSource,
  queryParamTerm,
  setProductConfigurations,
  isLoadingQuantityPacks = false
}) => {
  const isSeatsRedesignUngated = usePricingLibSelector(getIsUngatedForSeats);
  const quantityPackApiName = useAppSelector(state => {
    if (!additionalUnitSkuId) {
      return null;
    }
    const sku = skuSelector(state, {
      skuId: additionalUnitSkuId
    });
    return sku === null || sku === void 0 ? void 0 : sku.quantityPackApiName;
  });
  const onContactQuantityChange = useAppSelector(state => quantity => {
    if (!additionalUnitSkuId) return;
    const {
      id: currentBaseProductId,
      productLine
    } = productForSkuIdSelector(state, {
      skuId: additionalUnitSkuId
    });
    const currentBaseSkuId = currentSkuIdForProductSelector(state, {
      productId: currentBaseProductId
    });
    const ownedProductVersion = productVersionFromProductInventorySelector(state, {
      productAttributeFilters: {
        productId: currentBaseProductId
      }
    });
    const ownedProductSkuId = ownedProductVersion && ownedProductVersion.skuId;
    const isLegacyMarketingSku = currentBaseSkuId && currentBaseSkuId !== ownedProductSkuId && productLine === MARKETING;

    // If we're on a legacy Marketing SKU, we need to enforce the
    // base current SKU is added anytime quantity packs are
    if (isLegacyMarketingSku && setProductConfigurations) {
      setProductConfigurations(() => {
        // This step removes duplicates
        const filteredConfigs = productConfigurations.filter(({
          skuId: configSkuId
        }) => configSkuId !== currentBaseSkuId && configSkuId !== additionalUnitSkuId);

        // Add the appropriate base SKU
        filteredConfigs.push(createProductConfig({
          skuId: currentBaseSkuId,
          quantity: 1
        }));

        // Add the appropriate quantityPack SKU
        if (quantity > 0) {
          filteredConfigs.push(createProductConfig({
            skuId: additionalUnitSkuId,
            quantity
          }));
        }
        return filteredConfigs;
      });
    } else {
      setAdditionalUnitQuantity(quantity, additionalUnitSkuId);
    }
  });
  const renderUnitsPicker = () => {
    if ((quantityPackApiName === 'additional-sales-seats' || quantityPackApiName === 'additional-service-seats') && !isSeatsRedesignUngated) {
      return /*#__PURE__*/_jsx(SeatsPickerMerchCardPreSeats, {
        additionalUnitSkuId: additionalUnitSkuId,
        additionalUnitQuantity: additionalUnitQuantity,
        onChange: setAdditionalUnitQuantity,
        productConfigurations: productConfigurations,
        trackingSource: trackingSource,
        queryParamTerm: queryParamTerm,
        isLoadingQuantityPacks: isLoadingQuantityPacks
      });
    } else if (quantityPackApiName === 'additional-marketing-contacts' || quantityPackApiName === 'additional-legacy-contacts') {
      if (isSeatsRedesignUngated) {
        // We will eventually separate this out, once we are able to migrate pre-seats to the new design that matches TB.
        // First we need to remove the toggles. Then we can start slashing props!
        return /*#__PURE__*/_jsx(IncludedContacts, {
          quantityPackSkuId: additionalUnitSkuId,
          trackingSource: trackingSource,
          queryParamTerm: queryParamTerm
        });
      }
      return /*#__PURE__*/_jsx(ContactsPickerCompactAll, {
        quantityPackSkuId: additionalUnitSkuId,
        onChange: onContactQuantityChange,
        quantityPackQuantity: additionalUnitQuantity,
        productConfigurations: productConfigurations,
        trackingSource: trackingSource,
        queryParamTerm: queryParamTerm,
        isLoadingQuantityPacks: isLoadingQuantityPacks
      });
    }
    return null;
  };
  return /*#__PURE__*/_jsx(_Fragment, {
    children: additionalUnitSkuId && renderUnitsPicker()
  });
};
export default AdditionalUnitsPickerCompactAll;